// Friendly display labels for Account.subType values, matching standard
// Indian bookkeeping/Tally/Schedule III terminology where the internal
// engine code would otherwise leak a US-style term straight into the UI
// (e.g. ACCOUNTS_RECEIVABLE -> "Accounts Receivable"). The enum values
// themselves stay as-is (server/src/models/account.js) since the posting
// engine only ever resolves accounts by code, never by subType string —
// this map is purely cosmetic.
const SUBTYPE_LABELS = {
  ACCOUNTS_RECEIVABLE: "Sundry Debtors (Trade Receivables)",
  ACCOUNTS_PAYABLE: "Sundry Creditors (Trade Payables)",
  COGS: "Purchases (Cost of Goods Sold)",
  INVENTORY: "Stock-in-Trade (Inventory)",
};

export function subTypeLabel(subType) {
  if (SUBTYPE_LABELS[subType]) return SUBTYPE_LABELS[subType];
  return (subType || "")
    .toLowerCase()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
